module.exports = __webpack_public_path__ + "img/bg-img.2133e713.png";